import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/home/login/login',
    method: 'post',
    data
  })
}

export function getInfo (token) {
  return request({
    url: '/home/login/getInfo',
    method: 'get',
    params: { token }
  })
}

export function logout (data) {
  return request({
    url: '/home/login/logout',
    method: 'post',
    data
  })
}

export function getAgreement (data) {
  return request({
    url: '/home/login/getAgreement',
    method: 'post',
    data
  })
}

export function sendSMS (data) {
  return request({
    url: '/wap/user/sendSMS',
    method: 'post',
    data
  })
}

export function register (data) {
  return request({
    url: '/home/login/register',
    method: 'post',
    data
  })
}

export function findPass (data) {
  return request({
    url: '/home/login/findPass',
    method: 'post',
    data
  })
}

export function getLoginToken (data) {
  return request({
    url: '/home/login/getLogin_Token',
    method: 'post',
    data
  })
}
export function wxlogins (data) {
  return request({
    url: '/home/login/wxlogin',
    method: 'post',
    data
  })
}
export function bindTelst (data) {
  return request({
    url: '/home/login/bindTelst',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js